import { Flex, Link, Typography } from '@iheartjane/reefer';
import { pluralize } from '@iheartjane/utils';

export interface ProductAddedToastProps {
  productCount?: number;
  showCartLink?: boolean;
  storeId: number;
}

export const ProductAddedToast = ({
  productCount = 1,
  showCartLink = false,
  storeId,
}: ProductAddedToastProps) => {
  return (
    <Flex grow={1}>
      <Typography color="grays-white">
        Added {pluralize({ number: productCount, noun: 'product' })} to your bag
      </Typography>
      {showCartLink && (
        <Link
          color="grays-white"
          to={`/stores/${storeId}/cart`}
          ml={32}
          typography="body-bold"
        >
          View bag
        </Link>
      )}
    </Flex>
  );
};
